<template>
  <div class="app-container">
    <header class="header">
      <div class="header-top">
        <div class="pn header-top-contain">
          <div class="logo" @click="$router.push('/home')" v-if="path === 'login' || path === 'register'">
            <div class="img">
              <img :src="require('@/assets/layoutHome/header-logo.png')" height="38" alt=""/>
            </div>
          </div>
          <div v-else-if="path === 'setPwd'" style="width: 100%;display: flex;align-items: center;justify-content: space-between">
            <div class="logo" >
              <div class="img">
                <img :src="require('@/assets/layoutHome/header-logo.png')" height="64" alt=""/>
              </div>
            </div>
            <div class="top-right">
                <img style="width: 456px;height: 34px;margin-right: 96px" :src="require('@/assets/layoutHome/header-top-text.png')" height="88" alt=""/>
                <div class="user">
                  <div class="photo">
                    <img :src="avatarPhoto" width="36" height="36" v-if="avatarPhoto"/>
                    <img
                        v-else
                        :src="require('@/assets/img/center/neutral.png')"
                        width="36"
                        height="36"
                    />
                  </div>
                  <div>
                    <span style="color: white;font-size: 20px">
                      {{ name }}
                    </span>
                  </div>
              </div>
            </div>
          </div>
          <div class="logo" @click="$router.push('/home')" v-else>
            <div class="img">
              <div class="txt">返回首页</div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <keep-alive>
      <div class="main-contain">
        <router-view> </router-view>
      </div>
    </keep-alive>
    <Footer />

    <selRoleLogin :open.sync=selRoleLoginVisible switch-mode="all"  @roleLoginClose="selRoleLoginVisible=false"></selRoleLogin>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import Footer from "./footer.vue";
import selRoleLogin from "@/views/login/selRoleLogin.vue"
export default {
  name: "layoutPage",
  components: { Footer,selRoleLogin },
  props: {},
  data() {
    return {
      selRoleLoginVisible: false,
      navList: [
        {
          key: "home",
          label: "首页",
        },
        {
          key: "news",
          label: "教育资讯",
        },
        {
          key: "apps",
          label: "教育应用",
        },
        {
          key: "aboutUs",
          label: "关于我们",
        },
      ],
      path: this.$route.name,
    };
  },
  watch: {
    $route: {
      handler: function (to, from) {
        console.log(to);
        this.path = to.name;
        if (to.name == "newsDetail") {
          this.path = "news";
        } else if (to.name == "appsDetail") {
          this.path = "apps";
        }
      },
      immediate: true,
      deep: true,
    },
    hasTaken: {
      handler(newVal) {
        if (newVal) {
          this.nickname = this.name;
        } else {
          this.nickname = null;
        }
      },
      immediate: true,
    },
  },
  computed: {
    // path() {
    //   console.log(this.$route.name);
    //   return this.$route.name;
    // },
    hasTaken() {
      if (getToken()) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters(["name", "avatar"]),
    avatarPhoto() {
      return this.avatar
        ? process.env.VUE_APP_BASE_API +
            "/system/File/downOssFile?uuid=" +
            this.avatar
        : null;
    },
  },
  created() {},
  mounted() {},
  methods: {
    navto(item) {
      this.$router.push("/" + item.key);
    },
    logout() {
      this.$confirm("确定要退出平台吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("LogOut")
          .then(() => {
            this.$router.push("/login");
            //location.href = "/";
          })
          .catch((err) => {});
      });
    },
    handleCommand(command) {

      if (command == "logout") {
        this.logout();
      }else if (command == "swtich"){
        if (this.$store.state.user.allRoles.length === 1 && this.$store.state.user.roleList.length === 1) {
          let loginRole = this.$store.state.user.allRoles[0]?.roleName || sessionStorage.getItem('loginRoleName');
          this.$message({
            message: `当前只有一个角色【${loginRole}】，无需切换！`, // 动态显示角色名称
            type: "warning",
            duration: 3000, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-info", // 添加图标
          });
        }else {
          this.selRoleLoginVisible=true
        }

        // this.$router.push({ path: "/sel", query: { switchMode: 'all' } }).catch(() => {});
      }else {
        this.$router.push("/" + command);
      }
    },
  },
};
</script>
<style scoped>
header {
  height: 88px;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  /* padding: 0 80px 0 200px; */
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  box-sizing: border-box;
  white-space: nowrap;
  box-shadow: 0 0 5px 0 #8b8b8b5f;
}
header .logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}
header .logo .img {
  width: 251px;
  height: 88px;
  margin-right: 10px;
  display: flex;
  align-items: center;
}
header .logo .txt {
  font-size: 18px;
  color: #101010;
  font-family: Source Han Sans;
  font-weight: 500;
}
nav {
  display: flex;
  align-items: center;
  margin-left: 10%;
  flex: 1;
}
.nav-item {
  margin-right: 54px;
  cursor: pointer;
}
.login.el-button--primary {
  background: #e2ecff;
  border-color: #e2ecff;
  color: rgba(37, 37, 37, 0.9);
}
.nav-item {
  margin-right: 54px;
  display: inline-block;
  height: 100%;
  line-height: 64px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
}

.nav-item.cur {
  font-weight: bold;
  color: rgba(7, 107, 242, 1);
}
.nav-item::before {
  content: "";
  display: inline-block;
  border-bottom: 3px solid rgba(7, 107, 242, 1);
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%) scaleX(0);
  transition: 0.2s ease-in-out;
  opacity: 0;
}

.nav-item.cur::before,
.nav-item:hover::before {
  opacity: 1;
  transform: translate(-50%) scaleX(1);
}
.main-contain {
  min-height: calc(100vh - 296px);
  display: flex;
  justify-content: center;
  margin-top: 88px;
}

.user {
  display: flex;
  align-items: center;
}
.user .photo {
  margin-right: 6.7px;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  overflow: hidden;
}
.user .user-menu-item {
  margin-left: 10px;
  cursor: pointer;
  color: #076bf2;
}

.header-top {
  height: 88px;
  align-items: center;
  display: flex;
  width: 100%;
  background: url("@/assets/layoutHome/header-top.png");
  background-size: cover;
}

.header-top-contain {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.top-right {
  display: flex;
  align-items: center;
}

.el-dropdown-menu {
  padding: 12px 0;
  text-align: center;
  min-width: 160px;
  line-height: 40px;
}

.el-dropdown-menu__item {
  font-size: 18px !important;
  padding: 12px 20px;
}
</style>
